<!--  -->
<template>
  <div class="section">
    <div class="content" v-for="(item, k) in planData" :key="k">
      <h1>
        <b>{{ item.stageName }}</b
        ><span>{{ item.stageTime }}</span>
      </h1>
      <div class="box">
        <h2>
          <span>{{ item.stageTarget }}</span
          ><b @click="toSudy(item)" v-if="item.hasPageJump">去学习</b>
        </h2>
        <div class="richHtml" v-show="item.stagePlan" v-html="item.stagePlan"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { reqSchemeUrl } from '@/api/openMini';
import wx from 'weixin-js-sdk';
import { miniSchemeUrl } from '@/utils/common';


export default {
  components: {},
  data() {
    return {};
  },
  props: {
    planData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  watch: {},
  methods: {
    toSudy(data) {
      const { hasPageJump, pageUrl } = data;
      if (hasPageJump === 1) {
        this.openLink(pageUrl);
      } else {
        this.openMiniPath(pageUrl);
      }
    },
    openLink(pageUrl) {
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url: pageUrl }, false);
        return;
      }
      // if (this.$root.$data.miniprogram) {
      //   wx.miniProgram.navigateTo({
      //     url: path,
      //   });
      //   return;
      // }
      window.location.href = pageUrl;
    },
    async openMiniPath(pageUrl) {
        const path =pageUrl.indexOf('?')>-1? pageUrl.slice(0, pageUrl.indexOf('?')):pageUrl;
      const params = pageUrl.indexOf('?')>-1?pageUrl.slice(pageUrl.indexOf('?') + 1):'';
      if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: pageUrl,
        });
        return;
      }
      if (this.$root.$data.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/${pageUrl}`,
        });
        return;
      }
      const schemeLink= await  miniSchemeUrl('wxdb89cfa2bb60f779',path,params)
       window.location.href=schemeLink;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.section.calendar {
  .content {
    padding-bottom: 36px;
  }
}
.section {
  padding: 49px 36px 36px 36px;
  .content:last-child {
    border-left: none;
  }
  .content {
    position: relative;
    box-sizing: border-box;
    padding-bottom: 36px;
    padding-left: 47px;
    border-left: 4px dashed #e6e8ed;
    &::before {
      position: absolute;
      top: 0;
      left: -15px;
      width: 29px;
      height: 29px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examPlan/dot.png')
        no-repeat;
      background-size: 100%;
      content: '';
    }
    h1 {
      display: flex;
      justify-content: space-between;
      padding-bottom: 14px;
      b {
        color: #333;
        font-weight: 600;
        font-size: 29px;
      }
      span {
        color: #999;
        font-weight: 400;
        font-size: 25px;
      }
    }
    .box {
      width: 100%;
      // margin-bottom: 36px;
      padding: 22px 22px 0 22px;
      background: #f9fafd;
      border-radius: 14px;
      > h2 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          color: #333;
          font-weight: 400;
          font-size: 25px;
        }
        b {
          display: inline-block;
          width: 116px;
          height: 42px;
          color: #fff;
          font-weight: 500;
          font-size: 22px;
          line-height: 42px;
          text-align: center;
          background: #ff7f41;
          border-radius: 22px;
        }
      }
      .richHtml {
        padding-top: 22px;
        padding-bottom: 22px;
        color: #999;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
        ::v-deep a {
          color: #6191f2 !important;
        }
        ::v-deep p,::v-deep span,::v-deep div {
          color: #999 !important;
          font-weight: 400 !important;
          font-size: 22px !important;
          line-height: 33px !important;
        }
      }
    }
  }
}
</style>
